import React from "react";
import { Col } from "react-bootstrap";
import { arrayToOptions } from "../../helpers";
import { DIRECTION_ARRAY, SHORT_SUFFIX_NAMES } from "../../helpers/constants";
import Map from "./Map";
import { uplist } from "../../adapters/uplist";
import { Input, Select } from "../fields";

const suffixOptions = arrayToOptions(SHORT_SUFFIX_NAMES);
const directionOptions = arrayToOptions(DIRECTION_ARRAY);

const CustomAddressForm = () => {
  const getRegions = (value) => {
    return uplist
      .get(`/regions?search=${value}`)
      .then((res) =>
        res.data.map((region) => ({ value: region.id, label: region.name }))
      );
  };

  return (
    <>
      <Col md={3} className="mb-4">
        <Input
          type="text"
          sku="address_info.street_number"
          label="Street Number"
          required
        />
      </Col>
      <Col md={5} className="mb-4">
        <Input
          type="text"
          sku="address_info.street_name"
          label="Street Name"
          required
        />
      </Col>
      <Col md={2} className="mb-4">
        <Select
          sku="address_info.street_suffix"
          label="Street Suffix"
          options={suffixOptions}
          required
        />
      </Col>

      <Col md={3} className="mb-4">
        <Select
          sku="address_info.street_direction"
          label="Street Direction"
          options={directionOptions}
          isClearable
        />
      </Col>
      <Col md={7} className="mb-4">
        <Select
          loadOptions={getRegions}
          sku="address_info.region"
          label="Region"
          placeholder="Search..."
          required
        />
      </Col>
      <Col xs={12} className="mb-4">
        <Map required sku="address_info.latlng" />
      </Col>
    </>
  );
};

export default CustomAddressForm;
